import { Routes } from '@angular/router';
import { Kevlar2Component } from '@app/features/kevlar2-validation/kevlar2-validation.component';
import { Authority } from '@app/shared/utils/enums';

export const kevlar2Routes: Routes = [
    {
        path: 'kevlar2-validation',
        children: [
            {
                path: '',
                component: Kevlar2Component,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE, Authority.INTL, Authority.DFS]
                }
            }
        ]
    }
]